import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=601312f9&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&lang=ts&"
export * from "./UserEdit.vue?vue&type=script&lang=ts&"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=601312f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601312f9",
  null
  
)

export default component.exports